export function NamtechFooter() {
  return (
    <a href="https://www.namtech.mx" target="_blank" rel="noopener noreferrer"
      data-testid="namtech-footer" title="Desarrollado por NAMTECH — namtech.mx"
      className="fixed bottom-0 left-0 z-[60] flex items-center gap-2 pl-3 pr-4 py-1.5 bg-[#0B2A47]/85 backdrop-blur-md border-t border-r border-[#BC9538]/30 rounded-tr-lg text-[10px] tracking-wide text-white/55 hover:text-white transition-colors">
      <span className="hidden sm:inline">Desarrollado por</span>
      <img src="/namtech/svg/namtech-logo-horizontal-blanco.svg" alt="NAMTECH"
        className="h-3.5 w-auto opacity-85 hover:opacity-100 transition-opacity" />
    </a>
  );
}

export default NamtechFooter;
